import { IconChevronRight } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import RenderIf from 'components/RenderIf/RenderIf';
import { URLS } from 'services/urls';

interface NoOrganizationCompaniesProps {
    companyType: string;
    shouldRender: boolean;
}

const NoOrganizationCompanies: React.FC<NoOrganizationCompaniesProps> = ({ companyType, shouldRender }) => (
    <RenderIf isTrue={shouldRender}>
        <p className="mt-1 text-dark">
            {`You have no ${companyType} added to your Company list.`}
            <a
                href={URLS.PROJECTS_APP.COMPANIES}
                target="_blank"
                rel="noreferrer"
                className="cursor--pointer ml-1"
            >
                Add now
                <span className="ml-1 inline-block">
                    <NSIcon icon={IconChevronRight} />
                </span>
            </a>
        </p>
    </RenderIf>
);

export default NoOrganizationCompanies;
